import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeSiteLocationMutationVariables = Types.Exact<{
  input: Types.MergeSiteLocationInput;
}>;


export type MergeSiteLocationMutation = { __typename?: 'Mutation', mergeSiteLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLaborTypesMutationVariables = Types.Exact<{
  input: Types.SetLaborTypesInput;
}>;


export type SetLaborTypesMutation = { __typename?: 'Mutation', setLaborTypes: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetSiteLocationCoordinatesMutationVariables = Types.Exact<{
  input: Types.SetSiteLocationCoordinatesInput;
}>;


export type SetSiteLocationCoordinatesMutation = { __typename?: 'Mutation', setSiteLocationCoordinates: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetSiteTimeZoneMutationVariables = Types.Exact<{
  input: Types.SetSiteTimeZoneInput;
}>;


export type SetSiteTimeZoneMutation = { __typename?: 'Mutation', setSiteTimeZone: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetSiteContactsMutationVariables = Types.Exact<{
  input: Types.SetSiteContactsInput;
}>;


export type SetSiteContactsMutation = { __typename?: 'Mutation', setSiteContacts: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLocationDefaultSpaceTypeMutationVariables = Types.Exact<{
  input: Types.SetLocationDefaultSpaceTypeInput;
}>;


export type SetLocationDefaultSpaceTypeMutation = { __typename?: 'Mutation', setLocationDefaultSpaceType: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLocationOverheadRateMutationVariables = Types.Exact<{
  input: Types.SetLocationOverheadRateInput;
}>;


export type SetLocationOverheadRateMutation = { __typename?: 'Mutation', setLocationOverheadRate: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelScheduledOverheadRateMutationVariables = Types.Exact<{
  input: Types.CancelScheduledOverheadRateInput;
}>;


export type CancelScheduledOverheadRateMutation = { __typename?: 'Mutation', cancelScheduledOverheadRate: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type EditScheduledOverheadRateMutationVariables = Types.Exact<{
  input: Types.EditScheduledOverheadRateInput;
}>;


export type EditScheduledOverheadRateMutation = { __typename?: 'Mutation', editScheduledOverheadRate: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteSiteLocationMutationVariables = Types.Exact<{
  input: Types.DeleteSiteLocationInput;
}>;


export type DeleteSiteLocationMutation = { __typename?: 'Mutation', deleteSiteLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchDeleteSiteLocationsMutationVariables = Types.Exact<{
  input: Types.BatchDeleteSiteLocationsInput;
}>;


export type BatchDeleteSiteLocationsMutation = { __typename?: 'Mutation', batchDeleteSiteLocations: { __typename?: 'SiteLocationBulkActionPayload', siteLocations?: Array<{ __typename?: 'SiteLocationPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CombineSubLocationsMutationVariables = Types.Exact<{
  input: Types.CombineSubLocationsInput;
}>;


export type CombineSubLocationsMutation = { __typename?: 'Mutation', combineSubLocations: { __typename?: 'CombineSubLocationsPayload', survivorLocationId?: string | null, loserLocationId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevertSubLocationCombineMutationVariables = Types.Exact<{
  input: Types.RevertSubLocationCombineInput;
}>;


export type RevertSubLocationCombineMutation = { __typename?: 'Mutation', revertSubLocationCombine: { __typename?: 'RevertSubLocationCombinePayload', survivorLocationId?: string | null, loserLocationId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddSubLocationMutationVariables = Types.Exact<{
  input: Types.AddSubLocationInput;
}>;


export type AddSubLocationMutation = { __typename?: 'Mutation', addSubLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddBayPolesMutationVariables = Types.Exact<{
  input: Types.AddBayPolesInput;
}>;


export type AddBayPolesMutation = { __typename?: 'Mutation', addBayPoles: { __typename?: 'BayPolesPayload', created?: Array<string> | null, skipped?: Array<string> | null, siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateSubLocationMutationVariables = Types.Exact<{
  input: Types.UpdateSubLocationInput;
}>;


export type UpdateSubLocationMutation = { __typename?: 'Mutation', updateSubLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateSubLocationMutationVariables = Types.Exact<{
  input: Types.InactivateSubLocationInput;
}>;


export type InactivateSubLocationMutation = { __typename?: 'Mutation', inactivateSubLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveSubLocationMutationVariables = Types.Exact<{
  input: Types.RemoveSubLocationInput;
}>;


export type RemoveSubLocationMutation = { __typename?: 'Mutation', removeSubLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateSiteLocationMutationVariables = Types.Exact<{
  input: Types.InactivateSiteLocationInput;
}>;


export type InactivateSiteLocationMutation = { __typename?: 'Mutation', inactivateSiteLocation: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MergeSiteLocationDocument = new TypedDocumentString(`
    mutation MergeSiteLocation($input: MergeSiteLocationInput!) {
  mergeSiteLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetLaborTypesDocument = new TypedDocumentString(`
    mutation SetLaborTypes($input: SetLaborTypesInput!) {
  setLaborTypes(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetSiteLocationCoordinatesDocument = new TypedDocumentString(`
    mutation SetSiteLocationCoordinates($input: SetSiteLocationCoordinatesInput!) {
  setSiteLocationCoordinates(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetSiteTimeZoneDocument = new TypedDocumentString(`
    mutation SetSiteTimeZone($input: SetSiteTimeZoneInput!) {
  setSiteTimeZone(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetSiteContactsDocument = new TypedDocumentString(`
    mutation SetSiteContacts($input: SetSiteContactsInput!) {
  setSiteContacts(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetLocationDefaultSpaceTypeDocument = new TypedDocumentString(`
    mutation SetLocationDefaultSpaceType($input: SetLocationDefaultSpaceTypeInput!) {
  setLocationDefaultSpaceType(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetLocationOverheadRateDocument = new TypedDocumentString(`
    mutation SetLocationOverheadRate($input: SetLocationOverheadRateInput!) {
  setLocationOverheadRate(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const CancelScheduledOverheadRateDocument = new TypedDocumentString(`
    mutation CancelScheduledOverheadRate($input: CancelScheduledOverheadRateInput!) {
  cancelScheduledOverheadRate(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const EditScheduledOverheadRateDocument = new TypedDocumentString(`
    mutation EditScheduledOverheadRate($input: EditScheduledOverheadRateInput!) {
  editScheduledOverheadRate(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const DeleteSiteLocationDocument = new TypedDocumentString(`
    mutation DeleteSiteLocation($input: DeleteSiteLocationInput!) {
  deleteSiteLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const BatchDeleteSiteLocationsDocument = new TypedDocumentString(`
    mutation BatchDeleteSiteLocations($input: BatchDeleteSiteLocationsInput!) {
  batchDeleteSiteLocations(input: $input) {
    siteLocations {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const CombineSubLocationsDocument = new TypedDocumentString(`
    mutation CombineSubLocations($input: CombineSubLocationsInput!) {
  combineSubLocations(input: $input) {
    survivorLocationId
    loserLocationId
    errors {
      code
      message
    }
  }
}
    `);
export const RevertSubLocationCombineDocument = new TypedDocumentString(`
    mutation RevertSubLocationCombine($input: RevertSubLocationCombineInput!) {
  revertSubLocationCombine(input: $input) {
    survivorLocationId
    loserLocationId
    errors {
      code
      message
    }
  }
}
    `);
export const AddSubLocationDocument = new TypedDocumentString(`
    mutation AddSubLocation($input: AddSubLocationInput!) {
  addSubLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const AddBayPolesDocument = new TypedDocumentString(`
    mutation AddBayPoles($input: AddBayPolesInput!) {
  addBayPoles(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    created
    skipped
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const UpdateSubLocationDocument = new TypedDocumentString(`
    mutation UpdateSubLocation($input: UpdateSubLocationInput!) {
  updateSubLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const InactivateSubLocationDocument = new TypedDocumentString(`
    mutation InactivateSubLocation($input: InactivateSubLocationInput!) {
  inactivateSubLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const RemoveSubLocationDocument = new TypedDocumentString(`
    mutation RemoveSubLocation($input: RemoveSubLocationInput!) {
  removeSubLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const InactivateSiteLocationDocument = new TypedDocumentString(`
    mutation InactivateSiteLocation($input: InactivateSiteLocationInput!) {
  inactivateSiteLocation(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeSiteLocation: build.mutation<MergeSiteLocationMutation, MergeSiteLocationMutationVariables>({
      query: (variables) => ({ document: MergeSiteLocationDocument, variables })
    }),
    SetLaborTypes: build.mutation<SetLaborTypesMutation, SetLaborTypesMutationVariables>({
      query: (variables) => ({ document: SetLaborTypesDocument, variables })
    }),
    SetSiteLocationCoordinates: build.mutation<SetSiteLocationCoordinatesMutation, SetSiteLocationCoordinatesMutationVariables>({
      query: (variables) => ({ document: SetSiteLocationCoordinatesDocument, variables })
    }),
    SetSiteTimeZone: build.mutation<SetSiteTimeZoneMutation, SetSiteTimeZoneMutationVariables>({
      query: (variables) => ({ document: SetSiteTimeZoneDocument, variables })
    }),
    SetSiteContacts: build.mutation<SetSiteContactsMutation, SetSiteContactsMutationVariables>({
      query: (variables) => ({ document: SetSiteContactsDocument, variables })
    }),
    SetLocationDefaultSpaceType: build.mutation<SetLocationDefaultSpaceTypeMutation, SetLocationDefaultSpaceTypeMutationVariables>({
      query: (variables) => ({ document: SetLocationDefaultSpaceTypeDocument, variables })
    }),
    SetLocationOverheadRate: build.mutation<SetLocationOverheadRateMutation, SetLocationOverheadRateMutationVariables>({
      query: (variables) => ({ document: SetLocationOverheadRateDocument, variables })
    }),
    CancelScheduledOverheadRate: build.mutation<CancelScheduledOverheadRateMutation, CancelScheduledOverheadRateMutationVariables>({
      query: (variables) => ({ document: CancelScheduledOverheadRateDocument, variables })
    }),
    EditScheduledOverheadRate: build.mutation<EditScheduledOverheadRateMutation, EditScheduledOverheadRateMutationVariables>({
      query: (variables) => ({ document: EditScheduledOverheadRateDocument, variables })
    }),
    DeleteSiteLocation: build.mutation<DeleteSiteLocationMutation, DeleteSiteLocationMutationVariables>({
      query: (variables) => ({ document: DeleteSiteLocationDocument, variables })
    }),
    BatchDeleteSiteLocations: build.mutation<BatchDeleteSiteLocationsMutation, BatchDeleteSiteLocationsMutationVariables>({
      query: (variables) => ({ document: BatchDeleteSiteLocationsDocument, variables })
    }),
    CombineSubLocations: build.mutation<CombineSubLocationsMutation, CombineSubLocationsMutationVariables>({
      query: (variables) => ({ document: CombineSubLocationsDocument, variables })
    }),
    RevertSubLocationCombine: build.mutation<RevertSubLocationCombineMutation, RevertSubLocationCombineMutationVariables>({
      query: (variables) => ({ document: RevertSubLocationCombineDocument, variables })
    }),
    AddSubLocation: build.mutation<AddSubLocationMutation, AddSubLocationMutationVariables>({
      query: (variables) => ({ document: AddSubLocationDocument, variables })
    }),
    AddBayPoles: build.mutation<AddBayPolesMutation, AddBayPolesMutationVariables>({
      query: (variables) => ({ document: AddBayPolesDocument, variables })
    }),
    UpdateSubLocation: build.mutation<UpdateSubLocationMutation, UpdateSubLocationMutationVariables>({
      query: (variables) => ({ document: UpdateSubLocationDocument, variables })
    }),
    InactivateSubLocation: build.mutation<InactivateSubLocationMutation, InactivateSubLocationMutationVariables>({
      query: (variables) => ({ document: InactivateSubLocationDocument, variables })
    }),
    RemoveSubLocation: build.mutation<RemoveSubLocationMutation, RemoveSubLocationMutationVariables>({
      query: (variables) => ({ document: RemoveSubLocationDocument, variables })
    }),
    InactivateSiteLocation: build.mutation<InactivateSiteLocationMutation, InactivateSiteLocationMutationVariables>({
      query: (variables) => ({ document: InactivateSiteLocationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeSiteLocationMutation, useSetLaborTypesMutation, useSetSiteLocationCoordinatesMutation, useSetSiteTimeZoneMutation, useSetSiteContactsMutation, useSetLocationDefaultSpaceTypeMutation, useSetLocationOverheadRateMutation, useCancelScheduledOverheadRateMutation, useEditScheduledOverheadRateMutation, useDeleteSiteLocationMutation, useBatchDeleteSiteLocationsMutation, useCombineSubLocationsMutation, useRevertSubLocationCombineMutation, useAddSubLocationMutation, useAddBayPolesMutation, useUpdateSubLocationMutation, useInactivateSubLocationMutation, useRemoveSubLocationMutation, useInactivateSiteLocationMutation } = injectedRtkApi;
